'use strict';

function BreadcrumbsController ($scope, sbNavDrawerService) {
  var viewManager = null;
  
  this.init = function (pageId) {
    viewManager = sbNavDrawerService.getViewManager(pageId);
  };

  this.loadView = function (viewId) {
    viewManager.stackRevertTo(viewId);
    $scope.$emit('sbNavDrawer:loadView', viewId);
  };

  this.getViewStack = function () {
    return viewManager.stackGet();
  };
}

module.exports  = BreadcrumbsController;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/breadcrumbs/BreadcrumbsController.js